// extracted by mini-css-extract-plugin
module.exports = {"bounceInLeftAnimation":"SectionTemplatesContent_bounceInLeftAnimation__5lSS9","bounceInLeft":"SectionTemplatesContent_bounceInLeft__ory_9"};